/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HealthHistoryAllergiesEditAliases {
  ACTION_DELETE_HEALTH_HISTORY_ALLERGIES = 'action-delete-health-history-allergies',
  ACTION_NEW_HEALTH_HISTORY_ALLERGIES = 'action-new-health-history-allergies',
  ACTION_RELEASE_HEALTH_HISTORY_ALLERGIES = 'action-release-health-history-allergies',
  AUTOCOMPLETE_APPROACH = 'autocomplete-approach',
  AUTOCOMPLETE_CAUSATIVE_AGENT = 'autocomplete-causative-agent',
  AUTOCOMPLETE_DATE_TYPE = 'autocomplete-date-type',
  AUTOCOMPLETE_ORIGIN = 'autocomplete-origin',
  AUTOCOMPLETE_REACTION_TYPE = 'autocomplete-reaction-type',
  AUTOCOMPLETE_SECURITY_LEVEL = 'autocomplete-security-level',
  CHECKBOX_DENIES_ALLERGIES = 'checkbox-denies-allergies',
  CHECKBOX_PATIENT_ALERTS = 'checkbox-patient-alerts',
  CHECKBOX_PROBLEMS_LIST = 'checkbox-problems-list',
  CONTEXTUAL_BAR_BODY = 'contextual-bar-body',
  DATE_FIELD_END_DATE = 'date-field-end-date',
  DATE_FIELD_LAST_DATE = 'date-field-last-date',
  DATE_FIELD_START_DATE = 'date-field-start-date',
  FETCH_ACTIVE_INGREDIENT = 'fetch-active-ingredient',
  FETCH_APPROACH = 'fetch-approach',
  FETCH_CAUSATIVE_AGENT = 'fetch-causative-agent',
  FETCH_DATE_TYPE = 'fetch-date-type',
  FETCH_DCB = 'fetch-dcb',
  FETCH_FAMILY = 'fetch-family',
  FETCH_MATERIAL_MEDICINE = 'fetch-material-medicine',
  FETCH_MATERIAL_MEDICINE_CLASS = 'fetch-material-medicine-class',
  FETCH_ORIGIN = 'fetch-origin',
  FETCH_REACTION_TYPE = 'fetch-reaction-type',
  FETCH_SECURITY_LEVEL = 'fetch-security-level',
  FIELD_ACTIVE_INGREDIENT = 'field-active-ingredient',
  FIELD_APPROACH = 'field-approach',
  FIELD_CAUSATIVE_AGENT = 'field-causative-agent',
  FIELD_CLASSIFICATION = 'field-classification',
  FIELD_CONDITION = 'field-condition',
  FIELD_DATE_TYPE = 'field-date-type',
  FIELD_DCB = 'field-dcb',
  FIELD_DENIES_ALLERGIES = 'field-denies-allergies',
  FIELD_END_DATE = 'field-end-date',
  FIELD_FAMILY = 'field-family',
  FIELD_HIGHLIGHT_INTENSITY_SEVERITY = 'field-highlight-intensity-severity',
  FIELD_LAST_DATE = 'field-last-date',
  FIELD_MATERIAL_MEDICINE = 'field-material-medicine',
  FIELD_MATERIAL_MEDICINE_CLASS = 'field-material-medicine-class',
  FIELD_NOTES = 'field-notes',
  FIELD_ORIGIN = 'field-origin',
  FIELD_PATIENT_ALERTS = 'field-patient-alerts',
  FIELD_PROBLEMS_LIST = 'field-problems-list',
  FIELD_REACTION_TYPE = 'field-reaction-type',
  FIELD_SECURITY_LEVEL = 'field-security-level',
  FIELD_START_DATE = 'field-start-date',
  FIELD_START_MONTH = 'field-start-month',
  FIELD_START_YEAR = 'field-start-year',
  FIELD_UNREGISTERED_CAUSATIVE_AGENT = 'field-unregistered-causative-agent',
  FORM_ONE = 'form-one',
  FORM_THREE = 'form-three',
  FORM_TWO = 'form-two',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_ACTIVE_INGREDIENT = 'input-active-ingredient',
  INPUT_DCB = 'input-dcb',
  INPUT_FAMILY = 'input-family',
  INPUT_MATERIAL_MEDICINE = 'input-material-medicine',
  INPUT_MATERIAL_MEDICINE_CLASS = 'input-material-medicine-class',
  INPUT_START_MONTH = 'input-start-month',
  INPUT_START_YEAR = 'input-start-year',
  INPUT_UNREGISTERED_CAUSATIVE_AGENT = 'input-unregistered-causative-agent',
  LAYOUT_HEALTH_HISTORY_ALLERGIES = 'layout-health-history-allergies',
  LOCATOR_ACTIVE_INGREDIENT = 'locator-active-ingredient',
  LOCATOR_DCB = 'locator-dcb',
  LOCATOR_FAMILY = 'locator-family',
  LOCATOR_FIELD_ACTIVE_INGREDIENT = 'locator-field-active-ingredient',
  LOCATOR_FIELD_DCB = 'locator-field-dcb',
  LOCATOR_FIELD_FAMILY = 'locator-field-family',
  LOCATOR_FIELD_MATERIAL_MEDICINE = 'locator-field-material-medicine',
  LOCATOR_FIELD_MATERIAL_MEDICINE_CLASS = 'locator-field-material-medicine-class',
  LOCATOR_MATERIAL_MEDICINE = 'locator-material-medicine',
  LOCATOR_MATERIAL_MEDICINE_CLASS = 'locator-material-medicine-class',
  MAPPER_APPROACH = 'mapper-approach',
  MAPPER_CAUSATIVE_AGENT = 'mapper-causative-agent',
  MAPPER_DATE_TYPE = 'mapper-date-type',
  MAPPER_ORIGIN = 'mapper-origin',
  MAPPER_REACTION_TYPE = 'mapper-reaction-type',
  MAPPER_SECURITY_LEVEL = 'mapper-security-level',
  PANEL_BODY = 'panel-body',
  PANEL_HEADER = 'panel-header',
  RADIO_GROUP_CLASSIFICATION = 'radio-group-classification',
  RADIO_GROUP_CONDITION = 'radio-group-condition',
  RADIO_GROUP_HIGHLIGHT_INTENSITY_SEVERITY = 'radio-group-highlight-intensity-severity',
  TEXT_APPROACH = 'text-approach',
  TEXT_AREA_NOTES = 'text-area-notes',
  TEXT_CAUSATIVE_AGENT = 'text-causative-agent',
  TEXT_DATE_TYPE = 'text-date-type',
  TEXT_ORIGIN = 'text-origin',
  TEXT_REACTION_TYPE = 'text-reaction-type',
  TEXT_SECURITY_LEVEL = 'text-security-level',
  WIZARD = 'wizard',
  WIZARD_STEP_ONE = 'wizard-step-one',
  WIZARD_STEP_THREE = 'wizard-step-three',
  WIZARD_STEP_TWO = 'wizard-step-two',
}
export { HealthHistoryAllergiesEditAliases };
